<template>
  <div id="app">
    <v-app>
      <v-toolbar v-if="this.$route.path != '/'" color="primary" dark fixed app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title>{{ this.$route.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat @click="logout">Logout</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-navigation-drawer v-if="this.$route.path != '/'" v-model="drawer" absolute temporary>
          <v-list>
            <v-list-tile>
              <v-list-tile-title class="title">
                DIY Blinds
              </v-list-tile-title>
            </v-list-tile>
          </v-list>

        <v-divider></v-divider>

        <v-list dense class="pt-0">
          <v-list-group prepend-icon="dashboard">
            <v-list-tile slot="activator">
              <v-list-tile-title>Dashboard</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="loggedInUser.position && ['manager'].includes(loggedInUser.position.role)" :to="{path: '/dashboard/sales'}">
              <v-list-tile-action>
                <!-- <v-icon>dashboard</v-icon> -->
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Sales</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="(loggedInUser.position && ['sales'].includes(loggedInUser.position.role))" :to="{path: '/dashboard/my-sales'}">
              <v-list-tile-action>
                <!-- <v-icon>dashboard</v-icon> -->
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>My Sales</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="loggedInUser.position && ['installations','manager'].includes(loggedInUser.position.role)" :to="{path: '/dashboard/installation'}">
              <v-list-tile-action>
                <!-- <v-icon>dashboard</v-icon> -->
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Installation</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="loggedInUser.position && ['account','manager'].includes(loggedInUser.position.role)" :to="{path: '/dashboard/account'}">
              <v-list-tile-action>
                <!-- <v-icon>dashboard</v-icon> -->
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Account</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="loggedInUser.position && ['manager'].includes(loggedInUser.position.role)" :to="{path: '/dashboard/motorisation'}">
              <v-list-tile-action>
                <!-- <v-icon>dashboard</v-icon> -->
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Motorisation</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="loggedInUser.position && ['manager'].includes(loggedInUser.position.role)" :to="{path: '/dashboard/samples'}">
              <v-list-tile-action>
                <!-- <v-icon>dashboard</v-icon> -->
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Samples</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>

          <v-list-tile :to="{path: '/customers'}">
            <v-list-tile-action>
              <v-icon>face</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Customers</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{path: '/carts'}">
            <v-list-tile-action>
              <v-icon>shopping_cart</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Carts</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- <v-list-tile :to="{path: '/quotesOld'}">
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>QuotesOld</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile> -->

          <v-list-tile :to="{path: '/quotes'}">
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Quotes</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{path: '/orders'}">
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Orders</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{path: '/sentToTWC'}">
            <v-list-tile-action>
              <v-icon>assignment</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Sent to TWC</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{path: '/freeSamples'}">
            <v-list-tile-action>
              <v-icon>redeem</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Free Samples</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- <v-list-tile :to="{path: '/freeSamplesNew'}">
            <v-list-tile-action>
              <v-icon>redeem</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Free Samples New</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile> -->

          <v-list-tile :to="{path: '/archive'}">
            <v-list-tile-action>
              <v-icon>archive</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Archive</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-group prepend-icon="settings">
            <v-list-tile slot="activator">
              <v-list-tile-title>Admin</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :to="{path: '/tomaxzones'}">
              <v-list-tile-content>
                <v-list-tile-title>Tomax Zones</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/customCurtains'}">
              <v-list-tile-content>
                <v-list-tile-title>Custom Curtain Calculator</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/postcodes'}">
              <v-list-tile-content>
                <v-list-tile-title>Postcodes</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="{path: '/promocodes'}">
              <v-list-tile-content>
                <v-list-tile-title>Promocodes</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="{path: '/installprices'}">
              <v-list-tile-content>
                <v-list-tile-title>Installprices</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/fabricCategories'}">
              <v-list-tile-content>
                <v-list-tile-title>Fabric Categories</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/fabrics'}">
              <v-list-tile-content>
                <v-list-tile-title>Fabrics</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/freeSamplePacks'}">
              <v-list-tile-content>
                <v-list-tile-title>Free Sample Packs</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/updatePassword'}">
              <v-list-tile-content>
                <v-list-tile-title>Update Password</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile v-if="loggedInUser.position && ['manager'].includes(loggedInUser.position.role)" :to="{path: '/sales-users'}">
              <v-list-tile-content>
                <v-list-tile-title>Sales User</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/orderDetails'}">
              <v-list-tile-content>
                <v-list-tile-title>Order Details</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile :to="{path: '/import/customers'}">
              <v-list-tile-action>
                <v-icon>cloud_upload</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Import Customers</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/import/orders'}">
              <v-list-tile-action>
                <v-icon>cloud_upload</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Import Orders</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile :to="{path: '/import/items'}">
              <v-list-tile-action>
                <v-icon>cloud_upload</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Import Items</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>
      <v-content>
          <router-view/>
      </v-content>
    </v-app>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      drawer: false,
      loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
      loggedIn: localStorage.hasOwnProperty('id_token')
    }
  },
  mounted () {
    // hiding in production
    // if (window.location.href.indexOf('localhost') > 0 || window.location.href.indexOf('stagingadmin') > 0) {
    //   this.notProduction = true
    // }
  },
  methods: {
    logout () {
      localStorage.removeItem('id_token')
      localStorage.removeItem('is_admin')
      localStorage.removeItem('user')
      this.$router.push({ name: 'Login', params: {error: 'logout'} })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue